import { styled } from "styled-components";
import { DownArrowIcon } from "icons";

export const DownArrow = styled(DownArrowIcon)<{ $rotate: number }>`
  transform: ${({ $rotate }) => `rotate(${$rotate}deg);`};
  transition: All 0.2s;
`;
